import { useMemo } from 'react';

import { GQLResponseError } from '@change-corgi/core/gql';
import { useTracking } from '@change-corgi/core/react/tracking';

type SuggestedPetitionErrorContext = Readonly<{ petitionId: string; submitError?: unknown; reason?: string }>;
type SignatureErrorTrackingResult = Readonly<{
	trackSuggestedPetitionSignError: (errorContext: SuggestedPetitionErrorContext) => void;
}>;

function stringifySubmitError(submitError: unknown) {
	if (submitError instanceof GQLResponseError) {
		return JSON.stringify({
			status: submitError.status,
			result: submitError.errors,
		});
	}
	if (submitError instanceof Error) {
		return submitError.message;
	}
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	if ((submitError as any).status) {
		const response = submitError as Response;
		return JSON.stringify({
			status: response.status,
		});
	}
	return JSON.stringify(submitError);
}

export function useSignatureErrorTracking(): ModelHookResult<undefined, SignatureErrorTrackingResult> {
	const track = useTracking();

	return {
		actions: useMemo(
			() => ({
				trackSuggestedPetitionSignError: ({ petitionId, submitError, reason }: SuggestedPetitionErrorContext) => {
					void track('error', {
						type: 'sign_petition_card',
						petition_id: petitionId,
						server_error: !!submitError,
						reason,
						...(submitError
							? {
									mutation_response: stringifySubmitError(submitError),
								}
							: {}),
					});
				},
			}),
			[track],
		),
	};
}
